module.exports = __webpack_public_path__ + "img/kitchen-display.aed34699.webp";